import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { SpotlightViewer } from '../../components/spotlight/spotlight-viewer';

export const SpotlightViewerPage: FC = () => {
	const { spotlightId } = useParams<{ spotlightId: string }>();
	if (!spotlightId) {
		return null;
	}

	return <SpotlightViewer spotlightId={spotlightId} />;
};

export const Spotlight = {
	SpotlightViewerPage,
};
